var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"nav-bar"}},_vm._l((_vm.routers),function(item,index){return _c('span',{key:index},[(index !== 0)?_c('span',[_vm._v("/")]):_vm._e(),_vm._v(_vm._s(item)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }